import {
  ActionIcon,
  Button,
  Flex,
  Group,
  Menu,
  Table,
  Text,
  ThemeIcon,
} from '@mantine/core'
import classes from './AdminSettings.module.css'
import { IconDots, IconGripVertical } from '@tabler/icons-react'
import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'

const MOCK_DATA = [
  {
    name: 'Announcement',
    subcategories: 2,
  },
  {
    name: 'Application',
    subcategories: 5,
  },
  {
    name: 'Health',
    subcategories: 5,
  },
  {
    name: 'Identification',
    subcategories: 4,
  },
  {
    name: 'Verification',
    subcategories: 8,
  },
]

export const FileCategories = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('File Categories'))
  })

  const rows = MOCK_DATA.map((item) => (
    <Table.Tr key={item.name}>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Group gap={5}>
          <ThemeIcon variant="transparent" color="gray.7">
            <IconGripVertical size={22} />
          </ThemeIcon>
          <Text size="sm" ml={5}>
            {item.name}
          </Text>
        </Group>
      </Table.Td>
      <Table.Td>{item.subcategories}</Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Menu>
          <Menu.Target>
            <ActionIcon variant="default" radius="xl" aria-label="Options">
              <IconDots style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item color="dark">Edit</Menu.Item>
            <Menu.Item color="dark">Hide</Menu.Item>
            <Menu.Item color="dark">Replace</Menu.Item>
            <Menu.Item color="red" onClick={() => {}}>
              Delete
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Table.Td>
    </Table.Tr>
  ))

  return (
    <>
      <Flex justify="flex-end" p="xs">
        <Button>Add Category</Button>
      </Flex>
      <Table withRowBorders={false} verticalSpacing="xs">
        <Table.Thead>
          <Table.Tr className={classes.AdminSettings__thead}>
            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Name
              </Text>
            </Table.Th>

            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Subcategories
              </Text>
            </Table.Th>

            <Table.Th>
              <Text size="xs">5 results</Text>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </>
  )
}
